export default __webpack_public_path__ + "static/Group53-f4d9843b47843614d11cd1578946e5ce.svg";